import { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { PlaycastContext } from '../../components/PlaycastWrapper';
import constants from '@playcastdotio/GlobalConfig';
import {
  PAVILION_SHELL_BORDER,
  PAVILION_SHELL_GRADIENT,
  PAVILION_SHELL_RADIUS,
} from './pavilionShellStyles';
import { AccountInfoPage } from './AccountInfoPage';

const QR_IMAGE_MAP: Record<string, string> = {
  development: '/pc-qr-dev.png',
  preview: '/pc-qr-prere.png',
  production: '/pc-qr-prod.png',
};
const qrImageSrc = QR_IMAGE_MAP[constants.ENVIRONMENT] ?? '/pc-qr-dev.png';

export const PavilionPostLogin = () => {
  const context = useContext(PlaycastContext);
  const [isWindowBlurred, setIsWindowBlurred] = useState(false);
  const [showAccountInfo, setShowAccountInfo] = useState(false);

  useEffect(() => {
    let mounted = true;
    window.electron?.on('pavilion-window-blur', () => {
      if (mounted) setIsWindowBlurred(true);
    });
    window.electron?.on('pavilion-window-focus', () => {
      if (mounted) setIsWindowBlurred(false);
    });
    return () => {
      mounted = false;
    };
  }, []);

  const handleClose = () => {
    context.electronFunctions?.setWindowState('closed');
  };

  const handlePlaycastClick = () => {
    window.open('https://playcast.io/hosts', '_blank', 'noopener,noreferrer');
  };

  if (showAccountInfo) {
    return <AccountInfoPage onBack={() => setShowAccountInfo(false)} />;
  }

  return (
    <div className={`box-border flex h-full min-h-0 w-full flex-1 overflow-hidden ${isWindowBlurred ? PAVILION_SHELL_GRADIENT : 'bg-transparent'}`}>
      <div
        className={`relative box-border flex h-full min-h-0 w-full flex-col overflow-hidden ${PAVILION_SHELL_RADIUS} ${PAVILION_SHELL_BORDER} ${PAVILION_SHELL_GRADIENT} pt-5 pb-5 pl-[7px] pr-[7px]`}
      >
        <button
          type='button'
          onClick={handleClose}
          className='absolute right-2 top-2 z-10 flex size-9 items-center justify-center rounded-md text-[#FBBF24] transition-colors hover:text-[#FCD34D] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FBBF24]'
          aria-label='Close'
        >
          <FontAwesomeIcon icon={faXmark} className='size-5' />
        </button>

        <div className='flex min-h-0 flex-1 flex-col items-center justify-center gap-6'>
          <div>
            <h1 className='shrink-0 text-center text-[48px] tracking-tight font-["Inter"] text-[#FEF3C7]'>
              Play It
            </h1>
            <h1 className='shrink-0 text-center text-[48px] tracking-tight font-["Inter"] text-[#FEF3C7]'>
              Forward
            </h1>
          </div>

          <img
            src={qrImageSrc}
            alt='Scan to visit playcast.io'
            className='w-[180px] h-[180px] shrink-0 object-contain'
          />

          <button
            type='button'
            onClick={handlePlaycastClick}
            className='shrink-0 rounded-full bg-[#FBBF24] px-12 py-2.5 text-center text-xl font-semibold text-[#020617] transition-transform hover:scale-[1.02] active:scale-[0.98]'
          >
            Playcast
          </button>

          <button
            type='button'
            onClick={() => setShowAccountInfo(true)}
            className='shrink-0 text-[#FFFFFF] text-base font-medium transition-opacity hover:opacity-80'
          >
            Account Info
          </button>
        </div>
      </div>
    </div>
  );
};
